var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("base-tutorial", { attrs: { steps: _vm.steps } }, [
    _c("div", [
      _c("h2", [
        _vm._v(
          " Olá! Nesta etapa vamos normalizar os comportamentos cadastrados. "
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [
        _vm._v(
          " No filtro “Unidade(s)”, selecione a(s) unidade(s) com a(s) qual(is) você trabalhará nesta etapa. Após selecionadas, é possível visualizar todos os comportamentos cadastrados pelos servidores dessas unidades. "
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [
        _vm._v(
          " No filtro “Situação”, selecione a opção “Não associados”, para visualizar os comportamentos que devem ser associados a uma das doze competências, ou, caso o conteúdo cadastrado não seja um comportamento, deve ser associado a categoria “Outros”. "
        ),
      ]),
      _c("p", { staticClass: "warning--text" }, [
        _vm._v(
          " Importante! Ao associar um comportamento a uma competência, automaticamente, ele deixa a lista dos “Não associados” e passa a compor a lista dos “Associados”. "
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [
        _vm._v(
          " No filtro “Competência”, você pode selecionar uma ou todas as competências ou a categoria “outros” para visualizar os comportamentos associados a ela. "
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [
        _vm._v(
          " Os comportamentos serão apresentados em uma tabela com as seguintes colunas: comportamento; unidade; competência e importância. Na coluna “competência” você faz a associação de cada comportamento a sua respectiva competência. Caso o conteúdo cadastrado não seja um comportamento, deve ser associado a categoria “Outros”. "
        ),
      ]),
      _c("p", [
        _vm._v(
          " Importante! Antes de associar, recomenda-se visualizar a definição de cada competência repousando o cursor sobre ela. "
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("O sistema disponibiliza os recursos de:")]),
      _c("ul", [
        _c("li", [
          _c(
            "p",
            {
              staticClass:
                "text-start font-weight-medium info--text text-lg-h6",
            },
            [
              _vm._v(
                " Ordenar por: organiza os comportamentos de acordo com a competência; o comportamento; a importância e a unidade. Ainda é possível organizar em ordem alfabética, utilizando a seta. "
              ),
            ]
          ),
        ]),
        _c("li", [
          _c(
            "p",
            {
              staticClass:
                "text-start font-weight-medium info--text text-lg-h6",
            },
            [
              _vm._v(
                " Pesquisar: possibilita a busca por qualquer termo cadastrado. "
              ),
            ]
          ),
        ]),
        _c("li", [
          _c(
            "p",
            {
              staticClass:
                "text-start font-weight-medium info--text text-lg-h6",
            },
            [
              _vm._v(
                " Baixar XLS: É possível baixar a lista dos comportamentos cadastrados. "
              ),
            ]
          ),
        ]),
      ]),
    ]),
    _c("div", [
      _c("h2", [
        _c("p", [
          _vm._v(
            " Após a associação de todos os comportamentos, deve-se baixar a lista e analisá-los, tendo como referência o quadro de comportamentos para cada competência. "
          ),
        ]),
        _c("p", [
          _vm._v(
            " Faz-se necessário contar a recorrência de cada comportamento para estabelecer os 50 mais representativos da unidade. É recomendável editar apenas os 50 comportamentos e arquivar os originais. Para cada competência é orientado o quantitativo mínimo de 3 e máximo de 8 comportamentos. Dos 50 comportamentos, deve-se definir os 3 mais estratégicos para a unidade e a eles atribuir a importância de valor 3. "
          ),
        ]),
        _c("p", [
          _vm._v(
            " Ao final, selecione os 50 comportamentos e clique no botão “Normalizar” e, em seguida, no botão “Finalizar”, consolidando o mapeamento comportamental. "
          ),
        ]),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("Importante!")]),
      _c("h2", [
        _vm._v(
          " O botão “Finalizar” só será disponibilizado após a normalização dos 50 comportamentos, clique para consolidar. É possível, dentro do prazo estabelecido para a normalização comportamental, reverter a normalização de um comportamento, caso necessário editar ou substituir. "
        ),
      ]),
      _c("p", { staticClass: "warning--text" }, [
        _vm._v(" Lembre-se de normalizá-lo e finalizar a consolidação. "),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }